import { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { Footer } from '@components/Footer/Footer';
import { LoadingPage, ServerErrorPage } from '@components/Loader/Loader';
import UserNavbar from '@components/Navbar/Navbar';
import setSubNavVisible from '@features/SubNav';
import { planDetailsApi } from '@reducers/plan';

const fetchInitialDataToCache = () => {
  const isLoading = [];
  const isError = [];
  const fieldDescription = planDetailsApi.useGetFieldDescriptionQuery();
  const queries = [fieldDescription];
  queries.forEach((query) => {
    if (query.isLoading) {
      isLoading.push(query.isLoading);
    }
    if (query.isError) {
      isError.push(query.isError);
    }
  });
  return { isLoading: isLoading.length > 0, isError: isError.length > 0 };
};

const Layout = () => {
  const { isLoading: initialLoading, isError: initialError } =
    fetchInitialDataToCache();

  const { is_hijacked: isHijacked } =
    useSelector((state) => state.auth.user) || '';
  const containerID = isHijacked ? 'main-container-hijacked' : 'main-container';
  return (
    <>
      <UserNavbar />
      <Container id={containerID} className="container-fluid">
        {initialLoading ? <LoadingPage /> : null}
        {initialError ? <ServerErrorPage /> : null}
        {!initialLoading && !initialError ? <Outlet /> : null}
      </Container>
      <Footer />
    </>
  );
};
export const LayoutWithSubNav = ({ navId }) => {
  useEffect(() => setSubNavVisible(navId));
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default Layout;
